import { createSlice } from "@reduxjs/toolkit";

// Initial state for inventory
const initialState = {
  data: [],
  loading: false,
  error: null,
};

const inventorySlice = createSlice({
  name: "inventoryReport",
  initialState,
  reducers: {
    fetchInventoryRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchInventorySuccess(state, action) {
      // Assuming action.payload is the array of inventory items
      state.loading = false;
      state.data = action.payload;
    },
    fetchInventoryFailure(state, action) {
      state.loading = false;
      state.error = action.payload; // error message
    },
  },
});

// Export actions and reducer
export const {
  fetchInventoryRequest,
  fetchInventorySuccess,
  fetchInventoryFailure,
} = inventorySlice.actions;

export default inventorySlice.reducer;